var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPanoramas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f3fafe;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m8.88,3.26c-.1.79-.16,1.53,0,2.24h42.31v-2.24H8.88Zm-4.44,4.28v2.42h51.14v-2.42H4.43ZM0,12.11v44.58c.28.01.52.04.76.04,19.03.01,38.06,0,57.09,0,.54,0,1.06.01,1.59,0,.21-.01.42-.1.56-.13V12.11H0Zm57.68,42.32c-18.45.04-36.85.01-55.32.01V14.58h55.32v39.86Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m0,12.11v44.58c.28.01.52.04.76.04,19.03.01,38.06,0,57.09,0,.54,0,1.06.01,1.59,0,.21-.01.42-.1.56-.13V12.11H0Zm57.68,42.32c-18.45.04-36.85.01-55.32.01V14.58h55.32v39.86Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m4.43,9.97v-2.43h51.14v2.43H4.43Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m51.19,3.26v2.25H8.88c-.17-.72-.11-1.46,0-2.25h42.32Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanoramas);
export default __webpack_public_path__ + "static/media/Panoramas.5ede853fe0f4310ec6693ec9749488f0.svg";
export { ForwardRef as ReactComponent };